// src/utils/MathUtil.ts

class MathUtil {

    /** 获取每页第一个记录的索引
     * @param recordsPerPage 每页记录数
     * @param currentPage 当前页
     */
    public getPage1stIdx(recordsPerPage: number, currentPage: number) {
        return recordsPerPage * (currentPage - 1)
    }

    /** 获取给定索引在第几页上
     * @param recordsPerPage 每页记录数
     * @param idx 索引
     */
    public getPage(recordsPerPage: number, idx: number) {
        return Math.floor(idx / recordsPerPage) + 1
    }

    /** 获取每页第一个记录的索引
     * @param recordsPerPage1 旧的每页记录数
     * @param currentPage 当前页
     * @param recordsPerPage2 新的每页记录数
     */
    public getNewPage(recordsPerPage1: number, currentPage1: number, recordsPerPage2: number) {
        let idx = this.getPage1stIdx(recordsPerPage1, currentPage1)
        return this.getPage(recordsPerPage2, idx)
    }

    /** 扩展数据.
     * @param input 
     * @param size 
     * @returns 
     */
    public large(input: number[], size: number) {
        let repeat = Math.round(size / input.length)
        let ret: number[] = []
        for (let i = 0; i < input.length; i++) {
            const element = input[i]
            for (let j = 0; j < repeat; j++) {
                ret.push(element)
                if (ret.length >= size) break
            }
        }
        while (ret.length < size) {
            ret.push(input[input.length - 1])
        }
        return ret
    }

    /**
     * 获取数组中元素的取值范围(最小值，最大值)
     * @param list 数组
     * @param startIdx 开始索引
     * @param endIdx 结束索引
     * @returns 
     */
    public getRange(list: number[], startIdx: number, endIdx: number) {
        let min = list[startIdx]
        let max = list[startIdx]
        for (let i = startIdx + 1; i <= endIdx; i++) {
            const e = list[i]
            if (e < min) min = e
            if (e > max) max = e
        }
        return {
            min: min,
            max: max
        }
    }

    /** 有符号的字节转换为无符号的字节. */
    toUByte(signedByte: number) {
        return signedByte & 0xff
    }

    /** 求和. */
    sum(list: number[]) {
        let output = 0
        for (let i = 0; i < list.length; i++) {
            output += list[i]
        }
        return output
    }

    /** 求平均数. */
    average(list: number[]) {
        return this.sum(list) / list.length
    }

    /** 求样本方差. */
    variance(list: number[]) {
        let av = this.average(list)
        // console.log(`n:`, list.length)
        let output = 0
        for (let i = 0; i < list.length; i++) {
            output += (list[i] - av) * (list[i] - av)
        }
        return Math.floor(Math.sqrt(output / (list.length - 1)))
    }

}

export let mathUtil = new MathUtil()